import Customer from "@material-symbols/svg-500/rounded/folder_shared.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const CustomerIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Customer });
	return <Icon />;
};

export default memo(CustomerIcon);
